"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var OVERSIZED_THRESHOLD = 1.5;
var ImageLoading = /** @class */ (function (_super) {
    __extends(ImageLoading, _super);
    function ImageLoading() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loadState: 'loading',
            imgEl: null,
        };
        _this.ref = function (imageElement) {
            if (imageElement) {
                // The timeout fixes an issue with cached images in firefox where the naturalWidth is set one frame later
                setTimeout(function () {
                    if (imageElement.complete) {
                        if (imageElement.naturalWidth) {
                            _this.onLoad(imageElement);
                        }
                        else {
                            _this.onError();
                        }
                    }
                    else {
                        imageElement.onload = function () { return _this.onLoad(imageElement); };
                        imageElement.onerror = _this.onError;
                    }
                });
            }
            _this.setState({ imgEl: imageElement });
        };
        _this.onLoad = function (image) {
            _this.setState({ loadState: 'complete' });
            if (typeof process !== 'undefined' &&
                process.env &&
                process.env.NODE_ENV === 'development' &&
                image &&
                exports.imageIsOversized(image)) {
                var dpi = typeof window !== 'undefined' && window.devicePixelRatio > 1 ? window.devicePixelRatio : 1;
                var dpiStr = dpi > 1 ? " (x" + dpi + ")" : '';
                console.warn("Loaded image " + image.currentSrc + " is oversized. Reduce loaded image dimensions or use srcSet. " +
                    ("Rendered dimensions: " + image.width + "x" + image.height + " " + dpiStr) +
                    ("loaded image dimensions: " + image.naturalWidth + "x" + image.naturalHeight + " " + dpiStr));
            }
        };
        _this.onError = function () {
            _this.setState({ loadState: 'error' });
        };
        return _this;
    }
    ImageLoading.prototype.render = function () {
        var loadState = this.state.loadState;
        return this.props.children(this.ref, loadState);
    };
    ImageLoading.prototype.componentWillUnmount = function () {
        if (this.state.loadState === 'loading') {
            this.cancelImageLoad();
        }
    };
    ImageLoading.prototype.cancelImageLoad = function () {
        if (this.state.imgEl) {
            this.state.imgEl.onload = null;
            this.state.imgEl.onerror = null;
            this.state.imgEl.src = '';
        }
    };
    return ImageLoading;
}(React.Component));
exports.imageIsOversized = function (image) {
    return image.naturalWidth > image.width * OVERSIZED_THRESHOLD ||
        image.naturalHeight > image.height * OVERSIZED_THRESHOLD;
};
exports.default = ImageLoading;
//# sourceMappingURL=ImageLoading.js.map